import Card, { CardProps } from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import { orange } from '@mui/material/colors'
import { alpha } from '@mui/material/styles'
import styled from 'styled-components'

import variables from 'assets/styles/scss/shared/_variables.module.scss'

interface WrapperProps extends CardProps {
  $hovered?: boolean
  $checked?: boolean
  index?: any
  anchorelmap?: any
  $focused?: boolean
}

interface StyledTypographyProps
  extends React.ComponentPropsWithRef<typeof Typography> {
  style?: React.CSSProperties
}

const getCardHoverStyle = () => ({
  '@media only screen and (min-width: 1025px)': {
    '&:hover .add-tag-icon': {
      opacity: 1,
    },
  },
})

const pesudoStyle = (extraStyles = {}) => ({
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: '0.25rem',
    border: '2px solid transparent',
    zIndex: -1,
    transition: 'border-color 0.3s',
    ...extraStyles,
  },
})

const getCardBorderStyle = () => ({
  // boxShadow: `${Box_Shadow} !important`,
  // ...pesudoStyle({ borderColor: variables['primary-blue'] }),
})

const getCardCheckedStyle = () => ({
  ...pesudoStyle({ borderColor: 'rgba(0, 125, 255, 0.5)' }),
})

export const Wrapper = styled(Card)<WrapperProps>(
  ({ $hovered, $checked, index, anchorelmap }) => ({
    position: 'relative',
    padding: '1.75rem 1.5rem 1.5rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    zIndex: 0,
    outlineWidth: 0,

    '&:not(:first-of-type)': {
      marginTop: '1.5rem',
    },

    ...pesudoStyle(),
    ...($hovered && getCardHoverStyle()),
    // ...($focused && getCardBorderStyle()),
    ...($checked && getCardCheckedStyle()),
    ...(anchorelmap[index] && getCardBorderStyle()),

    '@media only screen and (max-width: 700px)': {
      ...pesudoStyle(),
      padding: '1rem !important',
    },
  }),
)

export const StyledTypography = styled(Typography)<StyledTypographyProps>(
  ({ style }) => ({
    display: 'block',

    p: {
      margin: 0,
    },
    '& em': {
      backgroundColor: alpha(orange[500], 0.4),
      color: variables['text-primary'],
      fontStyle: 'normal',
      borderRadius: '2px',
    },
    ...style,
  }),
)
